import { useEffect, useState } from "react";
import axios from "axios";
import SensorTable from "../../components/Tables/SensorTable";
import SensorForm from "../../components/Forms/SensorForm";
import NavBar from "../../components/NavBar/NavBar";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SensorPage = ({ auth, onLogout }) => {
    const [sensors, setSensors] = useState([]);
    const [selectedSensor, setSelectedSensor] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchSensors = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_BASE_URL}/sensors`, {
                headers: { Authorization: `Bearer ${auth.token}` } // authorization header
            });
            setSensors(response.data);
            setError(null);
        } catch (error) {
            if (error.response?.status === 401) {
                onLogout(); // Trigger logout on 401 error
            } else {
                setError(error.response?.data?.message || "Failed to load sensors. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (auth.token) {
            fetchSensors();
        } else {
            setError("Authentication token missing");
            setLoading(false);
        }
    }, [auth.token]);

    // Open the modal for adding a new sensor
    const handleAddNewSensor = () => {
        setSelectedSensor(null);
        setShowModal(true);
    };

    // Open the modal for editing a sensor
    const handleEditSensor = (sensor) => {
        setSelectedSensor(sensor);
        setShowModal(true);
    };

    // Close the modal
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSaveSensor = async (sensor) => {
        try {
            const headers = { Authorization: `Bearer ${auth.token}` };

            if (sensor.id) {
                const response = await axios.put(`${API_BASE_URL}/sensors/${sensor.id}`, sensor, { headers });
                setSensors((prevSensors) =>
                    prevSensors.map((s) => s.id === sensor.id ? response.data.sensor[0] : s)
                );
            } else {
                const response = await axios.post(`${API_BASE_URL}/sensors`, sensor, { headers });
                setSensors((prevSensors) => [ ...prevSensors, response.data.sensor ]);
            }
            handleCloseModal();
        } catch (error) {
            if (error.response?.status === 401) {
                onLogout(); // Trigger logout on 401 error
            } else {
                setError(error.response?.data?.message || "Failed to save sensor. Please try again.");
            }
        }
    };

    return (
        <>
            <NavBar auth={auth} onLogout={onLogout} />
            {error && <div className="alert alert-danger">{error}</div>}
            <SensorTable
                sensors={sensors}
                loading={loading}
                onEditSensor={handleEditSensor}
                onAddNewSensor={handleAddNewSensor}
            />
            <SensorForm
                selectedSensor={selectedSensor}
                onSave={handleSaveSensor}
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                auth={auth}
                onLogout={onLogout}
            />
        </>
    );
};

export default SensorPage;